export default __webpack_public_path__ + "static/media/TV_Escola.2a724f5a.png";